import { createContext, useState, useContext } from "react";

// Create context
export const MovieContext = createContext();

// Hook for easy access
export const useMovieContext = () => useContext(MovieContext);

export function MovieProvider({ children }) {
  const [movies, setMovies] = useState([]);   // full movie list
  const [filter, setFilter] = useState("All statuses"); 
  const [search, setSearch] = useState("");
  const [isAddModalOpen, setAddModalOpen] = useState(false);

  // Example actions
  const addMovie = (movie) => setMovies((prev) => [...prev, movie]);
  const deleteMovie = (id) => setMovies((prev) => prev.filter(m => m.id !== id));

  return (
    <MovieContext.Provider
      value={{
        movies,
        setMovies,
        filter,
        setFilter,
        search,
        setSearch,
        isAddModalOpen,
        setAddModalOpen,
        addMovie,
        deleteMovie,
      }}
    >
      {children}
    </MovieContext.Provider>
  );
}
